import React from "react"

import HamburgerNav from "./Header/HamburgerNav"
import { Link, withRouter } from "react-router-dom"
// import { getActivePath } from "RouteHelper"
import NavListItem from "./Header/NavListItem"
import UserPanel from "./Header/UserPanel"
import { connect } from "react-redux"
import logoImg from "assets/img/logo.png"
import logoImgGraphic from "assets/img/logo-graphic.png"
import logoImgText from "assets/img/logo-text.png"

/**
 * Main app Header
 */
const HeaderUser = (props) => {
    // Renders main navigation items
    const renderMainNavNodes = () => {
        let navNodes = []

        const navItems = [
            {
                routeDefinition: {
                    classname: "dashboard",
                    icon: "fad fa-tachometer-fast",
                    key: "DASHBOARD",
                    path: "/",
                    title: "Dashboard",
                }
            },
            {
                routeDefinition: {
                    classname: "dashboard",
                    icon: "fad fa-copy",
                    key: "DOCUMENTS",
                    path: "/",
                    title: "Documents",
                }
            },
            {
                routeDefinition: {
                    classname: "dashboard",
                    icon: "fad fa-comment-alt-exclamation",
                    key: "INCIDENTS",
                    path: "/",
                    title: "Incidents",
                }
            },
            {
                routeDefinition: {
                    classname: "dashboard",
                    icon: "fad fa-tasks",
                    key: "MY TASKS",
                    path: "/",
                    title: "My Tasks",
                }
            },
        ];

        if (navItems) {
            // console.log(navItems);
            navNodes = navItems.map(navItem => {
                const routeDef = navItem.routeDefinition;
                return (
                    <NavListItem
                        className="main"
                        key={routeDef.key}
                        path={routeDef.path === "/" ? routeDef.path : null}
                        // isActive={state.selectedMainNavItem === navItem}
                        onClick={() => {
                            window.scrollTo(0, document.body.scrollHeight);
                            if (props.setActiveTab) {
                                props.setActiveTab(navItem.routeDefinition.key);
                            }
                        }
                        }
                        icon={
                            <i
                                className={`icon ${
                                    routeDef.icon
                                        ? routeDef.icon
                                        : "fal fa-link"
                                }`}
                            />
                        }
                        title={routeDef.title}
                    />
                )
            })
        }

        return navNodes
    }

    return (
        <div className="header">
            <div className="logo">
                <Link to="/">
                    <span className="logo-single">
                        <img src={logoImg} alt="The Guard" />
                    </span>
                    <span className="logo-split">
                        <img
                            className="logo-split-graphic"
                            src={logoImgGraphic}
                            alt="The Guard"
                        />
                        <img
                            className="logo-split-text"
                            src={logoImgText}
                            alt="The Guard"
                        />
                    </span>
                </Link>
            </div>
            <div className="nav-panel">
                <div className="top-nav-panel">
                    <div className="main-nav">
                        <ul>
                            {renderMainNavNodes()}
                        </ul>
                    </div>
                    <div className="user-nav">
                        <UserPanel />
                    </div>
                    <div className="hamburger-nav">
                        <HamburgerNav />
                    </div>
                </div>
                <div className="sub-nav">
                    <ul>
                        {/* {renderSubNavNodes()} */}
                    </ul>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state /* , ownProps */) => ({});

const mapDispatchToProps = {};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HeaderUser)
);
